import React, { ReactElement, useContext, useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { saveValues } from '../features/values/potterware-file';
import ToolsSection from './tools-section';
import ExportContext from './export-context';

function DownloadView(): ReactElement {
  const { exports, label, fileNameInput } = PW.config.downloadPanel;

  let fileNameLabel: string;
  let fileNameParam: string;
  if (typeof fileNameInput === 'string') {
    fileNameParam = fileNameLabel = fileNameInput;
  } else {
    fileNameParam = fileNameInput.name;
    fileNameLabel = fileNameInput.label;
  }

  const [fileName, setFileName] = useState('');
  const dispatch = useDispatch();
  const { requestExport } = useContext(ExportContext);

  function fileNameOrDefault() {
    const date = moment().format('MM-DD-YY-HH-mm');
    return fileName ? fileName : 'potterware-' + date;
  }

  function onDownloadPotterwareClick(): void {
    dispatch(saveValues(fileNameOrDefault()));
  }

  function onExportButtonClick(exportName: string) {
    return function () {
      requestExport({ exportName, values: { [fileNameParam]: fileName } });
    };
  }

  return (
    <ToolsSection title={label}>
      <div className="inputs-list">
        <div className="inputs-list__item">
          <TextField
            label={fileNameLabel}
            variant="outlined"
            fullWidth
            size="small"
            value={fileName}
            onChange={(event) => setFileName(event.target.value)}
          />
        </div>

        {exports.map((config) => {
          if (typeof config !== 'string' && config.name === '$potterware-file')
            return (
              <div className="inputs-list__item" key={config.name}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={onDownloadPotterwareClick}
                >
                  {config.label}
                </Button>
              </div>
            );
          else {
            const label = typeof config === 'string' ? config : config.label;
            const name = typeof config === 'string' ? config : config.name;

            return (
              <div className="inputs-list__item" key={name}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={onExportButtonClick(name)}
                >
                  {label}
                </Button>
              </div>
            );
          }
        })}
      </div>
    </ToolsSection>
  );
}

export default DownloadView;
